import { Routes } from '@angular/router';
import { FailedComponent } from './failed/failed.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { PendingChangesGuard } from './shared/guards/PendingChangesGuard.guard';
import { TemplateDetailsResolver } from './cms/templates/templateDetails/templateDetails.resolver';
import { TemplatesResolver } from './cms/templates/templates.resolver';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { RolesGuard } from './shared/guards/roles.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MsalGuard } from '@azure/msal-angular';
import { EntriesResolver } from './cms/entries/entries.resolver';
import { EntriesDetailsResolver } from './cms/entries/entryDetails/entryDetails.resolver';
import { EntryQuestionEditResolver } from './cms/entries/entry-question-edit/entry-question-edit.resolver';
import { CompanyResolver } from './customer-service/company/company.resolver';
import { EmployeeProfileResolver } from './customer-service/employee-profile/employee-profile.resolver';

export const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  {
    path: 'dashboard-failed',
    component: FailedComponent,
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: 'cms/templates',
    loadComponent: () => import('./cms/templates/templates.component').then((c) => c.TemplatesComponent),
    canActivate: [MsalGuard, RolesGuard],
    resolve: { data: TemplatesResolver },
    data: { appRole: 'cms' }
  },
  {
    path: 'cms/templates/:id',
    loadComponent: () => import('./cms/templates/templateDetails/templateDetails.component').then((c) => c.TemplateDetailsComponent),
    canDeactivate: [PendingChangesGuard],
    resolve: { data: TemplateDetailsResolver },
    canActivate: [MsalGuard, RolesGuard],
    data: {
      appRole: 'cms',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
  },
  {
    path: 'cms/create-template',
    loadComponent: () => import('./cms/templates/templateDetails/templateDetails.component').then((c) => c.TemplateDetailsComponent),
    canDeactivate: [PendingChangesGuard],
    resolve: { data: TemplateDetailsResolver },
    canActivate: [MsalGuard, RolesGuard],
    data: {
      appRole: 'cms',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
  },
  {
    path: 'customerservice',
    loadComponent: () => import('./customer-service/customer-service.component').then((c) => c.CustomerServiceComponent),
    canActivate: [AuthGuard, RolesGuard],
    data: { appRole: 'customerservice' },
  },
  {
    path: 'customerservice/company/:id',
    loadComponent: () => import('./customer-service/company/company.component').then((c) => c.CustomerComponent),
    canActivate: [AuthGuard, RolesGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      appRole: 'customerservice',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
    resolve: { data: CompanyResolver },
    // Add this configuration to enable reload for the same URL
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'customerservice/company/:companyId/employee/:employeeId',
    loadComponent: () => import('./customer-service/employee-profile/employee-profile.component').then((c) => c.EmployeeProfileComponent),
    canActivate: [AuthGuard, RolesGuard],
    canDeactivate: [PendingChangesGuard],
    data: {
      appRole: 'customerservice',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
    resolve: { profileData: EmployeeProfileResolver }
  },
  {
    path: 'cms/entries',
    loadComponent: () => import('./cms/entries/entries.component').then((c) => c.EntriesComponent),
    canActivate: [MsalGuard, RolesGuard],
    resolve: { data: EntriesResolver },
    data: { appRole: 'cms' }
  },
  {
    path: 'cms/entries/:id',
    loadComponent: () => import('./cms/entries/entryDetails/entryDetails.component').then((c) => c.EntryDetailsComponent),
    canDeactivate: [PendingChangesGuard],
    resolve: { data: EntriesDetailsResolver },
    canActivate: [MsalGuard, RolesGuard],
    data: {
      appRole: 'cms',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
  },
  {
    path: 'cms/create-entry',
    loadComponent: () => import('./cms/entries/entryDetails/entryDetails.component').then((c) => c.EntryDetailsComponent),
    canDeactivate: [PendingChangesGuard],
    canActivate: [MsalGuard, RolesGuard],
    data: {
      appRole: 'cms',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
  },
  {
    path: 'cms/entry-question-edit/:entryId/:questionId',
    loadComponent: () => import('./cms/entries/entry-question-edit/entry-question-edit.component').then((c) => c.EntryQuestionEditComponent),
    canDeactivate: [PendingChangesGuard],
    canActivate: [MsalGuard, RolesGuard],
    resolve: { data: EntryQuestionEditResolver },
    data: {
      appRole: 'cms',
      confirmModalModel: {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "Don't save",
      },
    },
  },
  {
    path: '404',
    component: UnauthorizedComponent,
    data: { appRole: 'unauthorized' }
  },
  { path: '**', component: UnauthorizedComponent }
];
